import { create } from "zustand";

type MessageModalStoreType = {
  isOpen: boolean;
  message: string;
  callback: () => void;
  setIsOpen: (isOpen: boolean) => void;
  setMessage: (message: string) => void;
  setCallback: (callback: () => void) => void;
};
const MessageModalStore = create<MessageModalStoreType>((set) => ({
  isOpen: false,
  message: "",
  callback: () => {},
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
  setMessage: (message: string) => set({ message }),
  setCallback: (callback: () => void) => set({ callback }),
}));

export default MessageModalStore;
